/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"
import { TZyomuinListItem } from "../../service/driver/TZyomuin"
import ZyomuinService from "../../service/driver/zyomuinService"
import BusyoService from "../../service/master/busyo/busyoService"

import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../type/wijmoComponents"
import ComboBox from "../ComboBox"
import { T部所マスタ } from "../ComboBox/BusyoComboBox"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"

// defaultComboBox用
export type TItem = { name: string; value: any }
const boolList: TItem[] = [
  {
    name: "在籍",
    value: "0",
  },
  {
    name: "退職",
    value: "1",
  },
]

/**
 * 乗務員情報検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const ZyomuinSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    ZyomuinName?: string
    busyoCode?: string
    isBusyoReadOnly?: boolean
    setZyomuin: (value: TZyomuinListItem) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [部所コード, set部所コード] = useState<string | null>(
    props.busyoCode ? props.busyoCode : ""
  )
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [isInit部所ItemsSource, setIsInit部所ItemsSource] = useState(false)

  const [乗務員名, set乗務員名] = useState<string>()
  const [退職フラグ, set退職フラグ] = useState<string | null>(null)

  // combobox
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  const [退職フラグComboBox, set退職フラグComboBox] = useState<TWijmoComboBox<
    number,
    TItem
  > | null>(null)
  const [退職フラグIsLoadEnded, set退職フラグIsLoadEnded] =
    useState<boolean>(false)
  const [退職フラグItemSource, set退職フラグItemSource] = useState<TItem[]>()

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async () => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      const res = await new ZyomuinService().getList({
        部所コード: 部所コード ?? "",
        社員氏名: 乗務員名 ?? "",
        退職フラグ:
          退職フラグ != null && !wjcCore.isNullOrWhiteSpace(退職フラグ)
            ? parseInt(退職フラグ)
            : 0, // 基本は退職していないものを検索
      })
      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: TZyomuinListItem) => {
    props.setZyomuin(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null || 部所ComboBox == null || 退職フラグComboBox == null)
      return

    if (props.isShow) {
      // 表示時処理
      //APIより部所一覧を取得
      Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
        set退職フラグItemSource(boolList)
        set部所ItemSource(部所ListRes.data)
        setIsInit部所ItemsSource(true)
        props.ZyomuinName && set乗務員名(props.ZyomuinName)
      })
    } else {
      // 非表示時中身を空にして閉じる
      set部所コード("")
      set乗務員名("")
      set退職フラグ("0")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid, 部所ComboBox, 退職フラグComboBox])

  // propsからの部所コードが反応しない為、フラグで制御
  useEffect(() => {
    if (!isInit部所ItemsSource) return
    props.busyoCode && set部所コード(props.busyoCode)
    setIsInit部所ItemsSource(false)
  }, [props.busyoCode, isInit部所ItemsSource])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "乗務員検索"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <div className="search-condition-table">
                <div className="search-condition-row">
                  <ComboBox.Busyo
                    autoFocus={true}
                    placeholder="部所"
                    listFilter={(d) => d.運行部所フラグ === 1}
                    isAllSelect={true}
                    isReadOnly={props.isBusyoReadOnly}
                    itemsSource={部所ItemSource}
                    isLoadEnded={部所IsLoadEnded}
                    setIsLoadEnded={set部所IsLoadEnded}
                    setSelectedValue={set部所コード}
                    selectedValue={部所コード}
                    setSelectedItem={set部所}
                    ComboBox={部所ComboBox}
                    setComboBox={set部所ComboBox}></ComboBox.Busyo>
                  <div className="ms-2">
                    <TextInput
                      id="乗務員名"
                      name="乗務員名"
                      value={乗務員名}
                      setValue={set乗務員名}
                      maxLength={100}
                      placeholder="乗務員名"
                    />
                  </div>
                  <ComboBox.Default
                    className="max-w-10rem"
                    placeholder="退職"
                    itemsSource={退職フラグItemSource}
                    selectedValue={退職フラグ}
                    setSelectedValue={set退職フラグ}
                    isLoadEnded={退職フラグIsLoadEnded}
                    setIsLoadEnded={set退職フラグIsLoadEnded}
                    ComboBox={退職フラグComboBox}
                    setComboBox={set退職フラグComboBox}></ComboBox.Default>
                  <Button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault()
                      search()
                    }}>
                    <FontAwesomeIcon icon={faSearch} />
                    検索
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                header="選択"
                align={"center"}
                binding="荷主品名ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<TZyomuinListItem>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={80}
                header="社員CD"
                binding="社員コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={150}
                header="乗務員名"
                binding="社員氏名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={150}
                header="担当車輌"
                binding="車番"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={180}
                header="部所"
                binding="部所名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={"*"}
                header="備考"
                binding="備考"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default ZyomuinSearchModal
